import Cookies from 'universal-cookie';

const NUMBER_FORMAT_OPTIONS = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

const formatCurrency = (value, showCurrency = true) => {
  const cookies = new Cookies();
  const organization = cookies.get('organization');
  const currency = organization?.currency;

  if (showCurrency && currency === '') {
    throw new Error('Invalid currency code : ');
  }

  const formatOptions = showCurrency && currency ? { style: 'currency', currency, ...NUMBER_FORMAT_OPTIONS } : NUMBER_FORMAT_OPTIONS;

  let result = new Intl.NumberFormat('en-US', formatOptions).format(value);

  if (result.includes('IDR')) result = result.replace('IDR', 'Rp');

  return result;
};

export default formatCurrency;
